module.exports = __webpack_public_path__ + "static/Muli-BoldItalic-a7fe93f83e2226f31883cdfb97d9a101.ttf";